<div class="py-7 px-6 max-w-[90vw] flex flex-col items-center">
  <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] m-0 mb-1 text-center">Upload File</p>
  <p class="text-sm text-[var(--tertiary-text)] mb-5 text-center">Replace the current attached file.</p>

  <div class="bg-[var(--app-base)] rounded-lg px-4 py-4 mb-4 flex flex-col items-center gap-3 w-full">
    <input type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="visibility: hidden; position: absolute;" (change)="handleFileInput($event.target.files)" #fileinput />

    <button (click)="openFileInput()" type="button"
      class="py-1.5 px-4 border-none rounded-lg text-[12px] font-semibold bg-[var(--primary-dark)] text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all">
      <span class="material-icons text-[16px]">attach_file</span> ATTACH FILE
    </button>

    <div *ngIf="fileToUpload?.name" class="flex items-center text-[12px]">
      <span class="font-bold text-[var(--base-text-alt-dark)] mr-1.5">File Name:</span>
      <span class="text-[var(--tertiary-text)]">{{fileToUpload.name.length > 20 ? (fileToUpload.name | slice: 0 : 20) + '...': fileToUpload.name }}</span>
    </div>
  </div>

  <div class="flex justify-center gap-3 mt-4 w-full">
    <button (click)="closeDialog(false)" class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">Cancel</button>
    <button [disabled]="!fileToUpload" (click)="closeDialog(true)" class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition disabled:bg-[#E6E6E6] disabled:text-[#C3C3C3]">Upload</button>
  </div>
</div>
